import { forwardRef, useRef } from 'react';
import { DateRangePicker, CustomProvider } from 'rsuite';
import arEG from 'rsuite/locales/ar_EG';
import enUS from 'rsuite/locales/en_US';
import 'rsuite/DateRangePicker/styles/index.css';
import './rsuite-range-picker.scss';
import styles from './date-range-picker-menu.module.scss';
import type { IDateRangePickerMenu } from 'libs/design-system/src/types/date_range_picker/menu';
import {
  getDir,
  getHorizontalPlacement,
  getVerticalPlacement,
} from 'libs/design-system/src/utils/getPlacement';
import { Button } from '@unified-checkout/design-system';

export const DateRangePickerMenu = forwardRef<
  HTMLDivElement,
  IDateRangePickerMenu
>(
  (
    {
      lang = 'en',
      open,
      dateRange,
      disabledDate,
      onSelectDate,
      preDefinedRanges,
      actionBtnsProps,
      rangePickerBtnRef,
    },
    ref
  ) => {
    const autoHorizontalPlacement =
      typeof rangePickerBtnRef?.current === 'object' &&
      getHorizontalPlacement(rangePickerBtnRef, getDir());
    const autoVerticalPlacement =
      typeof rangePickerBtnRef?.current === 'object' &&
      getVerticalPlacement(rangePickerBtnRef);

      const wrapperRef= useRef<HTMLDivElement | null>(null)
      
    return (
      open && (
        <div
          className={styles['date-range-menu']}
          ref={ref}
          data-drp-menu-horizontal={
            autoHorizontalPlacement ? autoHorizontalPlacement : 'start'
          }
          data-drp-menu-vertical={
            autoVerticalPlacement ? autoVerticalPlacement : 'bottom'
          }
          date-range-menu-double="true"
        >
          {preDefinedRanges && (
            <div className={styles['date-range-menu__pre-defined-ranges']}>
              {preDefinedRanges.map((range, i: number) => (
                <div
                  key={`pre-selected-range-${i}`}
                  className={`
                  ${styles['date-range-menu__pre-defined-ranges__range']} 
                ${
                  range.selected
                    ? styles[
                        'date-range-menu__pre-defined-ranges__range--selected'
                      ]
                    : ''
                }
                ${
                  range.disabled
                    ? styles[
                        'date-range-menu__pre-defined-ranges__range--disabled'
                      ]
                    : ''
                }
                `}
                  onClick={() =>
                    range.onClickHandler &&
                    range.onClickHandler(
                      range.index,
                      range.selectionRange,
                      range.disabledRange
                    )
                  }
                >
                  {range.label}
                </div>
              ))}
            </div>
          )}

          <div className={styles['date-range-menu__picker-actions-wrapper']} ref={wrapperRef}>
            <div
              className={
                styles['date-range-menu__picker-actions-wrapper__picker']
              }
            >
              <CustomProvider locale={lang === 'en' ? enUS : arEG}>
                <DateRangePicker
                  showHeader={false}
                  open={open}
                  shouldDisableDate={disabledDate}
                  menuStyle={{ boxShadow: 'none', borderRadius: '0' }}
                  value={dateRange}
                  calendarSnapping
                  format="yyyy-MMM-dd"
                  onSelect={(value) => onSelectDate(value)}
                  container={() => wrapperRef.current as unknown as HTMLElement}
                />
              </CustomProvider>       
            </div>

            <div
              className={
                styles['date-range-menu__picker-actions-wrapper__actions']
              }
            >
              {actionBtnsProps?.map((btn, i: number) => (
                <Button
                  key={`drp-action-btn-${i}`}
                  size={btn.size}
                  color={btn.color}
                  variant={btn.variant}
                  text={btn.text}
                  disabled={btn.disabled}
                  onClickHandler={btn.onClickHandler}
                />
              ))}
            </div>
          </div>
        </div>
      )
    );
  }
);
